export default "__VITE_ASSET__CFXmbiR8__"